module.exports = __webpack_public_path__ + "static/media/btn-social-facebook.0978b500.png";